import { Checkbox
, FormControlLabel
, TableContainer
, Table
, TableBody
, TableCell
, TableRow
, Paper
, Tooltip
, Zoom
, Button
, LinearProgress } from '@material-ui/core';
import React from 'react';

import helpSvg from '../assets/img/help.svg';
import { connect, useDispatch, useSelector } from 'react-redux';
import State from '../states/State';
import { BatteryFormData } from './formData/BatteryFormData';

import { change, getFormValues } from 'redux-form';
import { makeStyles } from '@material-ui/core/styles';
import useStyles from '../styles/styles';

const formName = 'battery-form';

const useCustomStyles = makeStyles(theme => ({
  PeSubsidy_unselectable: {
    userSelect: 'none',
    alignItems: 'flex-start',
  },
  PeSubsidy_button: {
    margin: '0 10px 10px 0',
  },
}));

const SubsidieLabel = (props: any) => {
  return <div>
    <p style={{fontWeight: 'bold', padding: '13px 0', margin: 0}}>{props.label}</p>
    <span style={{
        fontSize: '13px', 
        fontStyle: 'italic', 
        textAlign: 'justify',
        color: '#9F9F9F',
      }}>{props.description}</span>
  </div>
}

type PeSubsidyProps = {
  readonly input?: any,
  readonly id: string,
  readonly label: string,
  readonly toolTip?: string,
  readonly formValues: BatteryFormData,
  readonly meta: { 
    touched: any, 
    error: any,
    form: any,
  }
}

const PeSubsidy: React.FC<PeSubsidyProps> = props => {
  const classes = useStyles();
  const classesCustom = useCustomStyles();
  const state = useSelector((state: State) => ({
    shell: state.shell,
  }));
  const dispatch = useDispatch();

  const processSubsides = (arr: any) => {
    const { state, 
      choice_type_product, 
      choice_type_install, 
      connected_to_reticulated_gas,
      exist_hws_gt_3yr } = props.formValues;
    // loop through tempArr with ordering item
    return arr && arr.map((subsidy: any) => {
      switch (subsidy.partNumber) {
        case "SVic_PV_Loan":
          subsidy = {
            ...subsidy,
            isActive: false,
          }
          break;
        case "SVic_PV_Rebate":
          subsidy = {
            ...subsidy,
            isActive: false,
          }
          break;
        case "SVic_Bat_Sto_Rebate":
          subsidy = {
            ...subsidy,
            isActive: exist_hws_gt_3yr === "yes",
          }
          break;
        case "SVic_PV_Business_Rebate":
          subsidy = {
            ...subsidy,
            isActive: false,
          }
          break;
        default: 
          subsidy = {
            ...subsidy,
            isActive: true,
            isChecked: true,
          }
          break;
      }
      return subsidy = {
        ...subsidy,
        isChecked: true,
      };
    });
  }
  const { exist_hws_gt_3yr, connected_to_reticulated_gas } = props.formValues;
  const convertToFormValue = (value: boolean) => {
    let temp = {};
    subsidies && subsidies.forEach((item: any) => {
      if (item.isActive) temp = {
        ...temp,
        [item.partNumber]: { 
          name: item.name,
          isChecked: value
        }
      }
    })
    // set form value
    dispatch(change(formName, 'subsidies', JSON.stringify(temp)));
  }

  const handleChecked = (event: any, key: number) => {
    // console.log(event.target.checked, subsidies[key], key);
    addSubsidy(subsidies[key], event.target.checked);
  }

  const addSubsidy = (item: any, checked: boolean) => {
    if (item)
      subsidyArr = {
        ...subsidyArr,
        [item.partNumber]: {
          name: item.name,
          isChecked: checked,
        }
      }
      dispatch(change(formName, 'subsidies', JSON.stringify(subsidyArr)));
  }

  const [subsidies, reSubsidies] = React.useState(state.shell.productData?.subsidies);
  let subsidyArr = props.formValues && props.formValues['subsidies'] ? JSON.parse(props.formValues['subsidies']) : {};
  const [isLoading, setIsLoading] = React.useState(true);
  
  React.useEffect(() => {
    convertToFormValue(true);
    reSubsidies(processSubsides(state.shell.productData?.subsidies));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exist_hws_gt_3yr, connected_to_reticulated_gas]);

  React.useEffect(() => {
    if (subsidies) {
      // console.log('change');
      isLoading && setIsLoading(false);
      convertToFormValue(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [subsidies]);

  return <div id={props.id} className={classes.control}>
    <div className={classes.labelArea}>
      <h3 className={classes.label}>
        {props.label}
      </h3>
      {props.toolTip && <Tooltip title={props.toolTip} TransitionComponent={Zoom} placement="right-end" arrow>
        <img src={helpSvg} alt="help" className={classes.iconHelp}/>
      </Tooltip>}
    </div>
    {isLoading ? <LinearProgress /> : <div>
      <Button className={classesCustom.PeSubsidy_button}
        size="small" 
        variant="outlined" 
        color="primary" 
        onClick={() => convertToFormValue(true)}>Select all</Button>
      <Button className={classesCustom.PeSubsidy_button}
        size="small" 
        variant="outlined" 
        color="primary" 
        onClick={() => convertToFormValue(false)}>Clear</Button>
      <TableContainer component={Paper} className={classes.table}>
      <Table aria-label="caption table">
        <TableBody>
          {subsidies && subsidies.map((item: any, key: number) => {
            return item.isActive && <TableRow key={key}>
              <TableCell align="left" variant="body" style={{width: '100%'}}>
                <FormControlLabel
                  className={classesCustom.PeSubsidy_unselectable}
                    control={
                        <Checkbox
                            checked={subsidyArr[item.partNumber] ? subsidyArr[item.partNumber].isChecked : false}
                            name={item.partNumber}
                            color="primary"
                            onClick={(event: any) => handleChecked(event, key)}
                        />
                    }
                    label={<SubsidieLabel label={item.name} description={item.description}/>}
                />
              </TableCell>
            </TableRow>
          })}
        </TableBody>
      </Table>
    </TableContainer>
    </div>}
  </div>
}

export default connect((state: State) => ({
  formValues: getFormValues(formName)(state)
}))(PeSubsidy);